import styled from 'styled-components';

const Layout = styled.div`
  max-width: 1024px;
  margin: 0 auto;
  padding: 48px;
`;

export default Layout;
